var React = require('react');

function InlineSvg (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"m7.6561 8.319 1.1321 3.0729 2.8576-7.0615L4.5837 7.187 7.656 8.319Zm-.907.907 1.75 4.7501h.5l4.5019-11.125-.377-.375-11.125 4.5v.5l4.75 1.75Z"}));
}

InlineSvg.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = InlineSvg;

InlineSvg.default = InlineSvg;
